import { sleep } from './sleep';
export class ResourceThrottler {
    constructor(options) {
        this.cache = new Map();
        const { callback, keyBuilder, ttl, maxSize } = options;
        this.callback = callback;
        this.keyBuilder = keyBuilder;
        this.ttl = ttl;
        this.maxSize = maxSize;
    }
    async get(...args) {
        const key = this.keyBuilder(...args);
        if (this.cache.has(key)) {
            return this.cache.get(key);
        }
        if (this.maxSize && this.cache.size >= this.maxSize) {
            const [keyToRemove] = this.cache.keys();
            this.cache.delete(keyToRemove);
        }
        const promise = this.callback(...args);
        this.cache.set(key, promise);
        if (this.ttl) {
            void sleep(this.ttl).then(() => this.cache.delete(key));
        }
        return promise;
    }
}
//# sourceMappingURL=ResourceThrottler.js.map